import React from 'react';
import './rangeDatePicker.scss';
import { DatePicker as AntdDatePicker } from 'antd';

export interface RangeDatePickerProps {
  disabled: boolean;
  disabledDate: (d: Date) => boolean;
  locale: string;
  format: string;
  onChange: (date: Date) => void;
  defaultValue?: string | [string, string];
  allowClear?: boolean;
}

const { RangePicker } = AntdDatePicker;

export const RangeDatePicker = ({
  disabled = false,
  disabledDate,
  locale,
  format,
  onChange,
  defaultValue,
  allowClear,
}: RangeDatePickerProps): JSX.Element => {
  return (
    <RangePicker
      disabled={disabled}
      disabledDate={(d) => {
        return !disabledDate ? false : disabledDate(d);
      }}
      className={`datepicker-form`}
      format={format}
      locale={locale}
      onChange={(event, date) => {
        onChange(date);
      }}
      defaultValue={defaultValue}
      allowClear={allowClear}
    />
  );
};
